"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var art_metrics_platforms_1 = require("./art-metrics-platforms");
function withARTWebMetrics(Component) {
    return function (props) { return React.createElement(Component, __assign({ artWebMetrics: art_metrics_platforms_1.default, record: art_metrics_platforms_1.default.record.bind(art_metrics_platforms_1.default), setDefaultProviders: art_metrics_platforms_1.default.setDefaultMetricsProviders.bind(art_metrics_platforms_1.default), addProvider: art_metrics_platforms_1.default.addProvidersToEventType.bind(art_metrics_platforms_1.default), removeProvider: art_metrics_platforms_1.default.removeProvidersFromEventType.bind(art_metrics_platforms_1.default) }, props)); };
}
exports.withARTWebMetrics = withARTWebMetrics;
//# sourceMappingURL=withARTWebMetrics.js.map